import { Checkbox, Form, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { GOOD_DEALS_API_SLUGS } from '~/helpers/adDetails/general';

function GoodDealCheckbox({ selectedGoodDeals, updateGoodDeals }) {
  const [goodDeals, setGoodDeals] = useState(selectedGoodDeals);
  const handleGoodDealChange = (checkedValues) => {
    setGoodDeals(checkedValues);
    updateGoodDeals(checkedValues);
  };

  useEffect(() => {
    setGoodDeals(selectedGoodDeals);
  }, [selectedGoodDeals]);
  return (
    <Form.Item label='Promotions'>
      <Checkbox.Group className='flex items-center gap-m' value={goodDeals} onChange={handleGoodDealChange}>
        {Object.entries(GOOD_DEALS_API_SLUGS).map(([key, value]) => (
          <Checkbox key={key} value={value.SLUG}>
            <Tag className={`round caption2 small${value.COLOR.light ? ' light' : ''}`} color={value.COLOR.color}>
              {value.LABEL}
            </Tag>
          </Checkbox>
        ))}
      </Checkbox.Group>
    </Form.Item>
  );
}

export default GoodDealCheckbox;
